<template>
	<div class="news-page">
		<DetailPage v-if="detail" :detail="detail" @back="detail = null" />
		<div v-else class="news-inner">
			<!-- 筛选栏 -->
			<div class="nf-bar">
				<!-- <div class="nf-group">
					<label>地区：</label>
					<select v-model="filter.region">
						<option value="">全部</option>
						<option v-for="r in regionOptions" :key="r" :value="r">{{ r }}</option>
					</select>
				</div> 
				<div class="nf-group">
					<label>农产品：</label>
					<select v-model="filter.product">
						<option value="">全部</option>
						<option v-for="p in productOptions" :key="p" :value="p">{{ p }}</option>
					</select>
				</div>-->
				<div class="nf-group nf-search">
					<label>关键字搜索：</label>
					<input v-model="filter.keyword" type="text" placeholder="请输入查询关键字" @keyup.enter="query" />
				</div>
				<button class="nf-query" @click="query">查询</button>
				<button class="nf-reset" @click="reset">重置</button>
			</div>

			<!-- 列表 -->
			<div class="nf-list">
				<div v-for="item in pagedList" :key="item.id" class="nf-item" @click="goInfo(item)">
					<div class="nf-date">
						<span class="d-ym">{{ item.ym }}</span>
						<span class="d-day">{{ item.day }}</span>
					</div>
					<div class="nf-main">
						<div class="nf-head">
							<div class="nf-title">{{ item.title }}</div>
							<div class="nf-source">来源：{{ item.source }}</div>
						</div>
						<div class="nf-summary">{{ item.summary }}</div>
					</div>
				</div>
				<div v-if="!loading && !pagedList.length" class="nf-empty">暂无相关资讯</div>
				<div class="nf-mask" v-if="loading">
					<span class="nf-spin"></span>
					<span class="nf-mask-text">加载中…</span>
				</div>
			</div>

			<!-- 分页 -->
			<div class="nf-pager">
				<span class="pg-total">共 {{ total }} 条</span>
				<span class="pg-btn" :class="{ disabled: page <= 1 }" @click="changePage(page - 1)">上一页</span>
				<span v-for="(p, idx) in visiblePages" :key="'pg' + idx" class="pg-num" :class="{ active: p === page, ellipsis: p === '...' }" @click="p !== '...' && changePage(p)">{{ p }}</span>
				<span class="pg-btn" :class="{ disabled: page >= pageCount }" @click="changePage(page + 1)">下一页</span>
			</div>
		</div>
	</div>
</template>

<script>
	import DetailPage from './DetailPage.vue'

	export default {
		name: 'NewsInfo',
		components: { DetailPage },
		data() {
			return {
				// 筛选：filter 为编辑态，applied 为点击查询后生效的条件
				filter: { region: '', product: '', keyword: '' },
				applied: { region: '', product: '', keyword: '' },
				page: 1,
				pageSize: 10,
				regionOptions: ['江苏', '山东', '湖南', '安徽', '北京', '广东', '河南', '四川', '辽宁', '江西', '陕西'],
				productOptions: ['蔬菜', '水果', '畜禽', '水产', '粮油'],
				// 服务端分页：当前页资讯、总量、加载态
				newsList: [],
				total: 0,
				loading: false,
				// 当前选中展示的资讯详情（非空则显示 DetailPage）
				detail: null,
				// 资讯列表（假数据，接口就绪后替换）
				newsAll: [{
						id: 101, ym: '2026/10', day: '29', region: '江苏', product: '蔬菜', source: '苏州市南环桥批发市场',
						title: '苏州南环桥市场：霜降过后，蔬菜价格总体平稳（2026.10.27）',
						summary: '霜降已过，早晚温差大。据市场监测数据显示，今日蔬菜批发价格总体平稳。叶菜类延续上周下跌趋势，花椰类小幅走低，葱蒜类、豆类、菌菇类总体平稳，夏季瓜果类有涨有跌，批发均价整体保持稳定。近期天气晴好，秋茬叶菜持续批量上市，供应充足，多数品种价格继续……'
					}, {
						id: 102, ym: '2026/10', day: '27', region: '山东', product: '蔬菜', source: '寿光地利农产品物流园',
						title: '寿光地利农产品物流园：2026.10.25周价格指数分析（2026.10.19-2026.10.25）',
						summary: '一、走势描述 本周寿光地利农产品物流园蔬菜价格定基指数为69.34点，较上周65.53点上涨3.81个百分点，环比涨幅5.8%，同比跌幅33.4%；蔬菜平均价格为1.89元/公斤，与上周1.85元/公斤相比，环比上涨2.2%，同比跌幅36.6%。本周监测的12大蔬菜类别指数中，5类指数上涨6类下跌……'
					}, {
						id: 103, ym: '2026/10', day: '27', region: '湖南', product: '蔬菜', source: '长沙马王堆农产品股份有限公司',
						title: '长沙马王堆农产品股份有限公司：蔬菜一周行情资讯',
						summary: '本周（2026.10.19—2026.10.25）对蔬菜价格行情监测结果显示：本周受监测的14种蔬菜日均供应量1333万公斤，较前一周日均供应量（1357万公斤）减少1.77%；蔬菜综合平均批发价2.66元/公斤，较前一周综合平均批发价（2.83元/公斤）下跌5.74%。本周14个品种……'
					}, {
						id: 104, ym: '2026/10', day: '26', region: '安徽', product: '蔬菜', source: '合肥周谷堆',
						title: '合肥周谷堆市场：一周行情分析（2026.10.16-2026.10.23）',
						summary: '一、蔬菜交易中心分析：本周蔬菜市场进场量环比、同比均下降，整体菜价稳中有跌。地产菜方面，本周地产叶菜供应量充足，前期合肥地区连续的雨水天气对于地产叶菜价格未造成影响，主要叶菜价格均处于低位；长途调运蔬菜价格稳中有跌，具体品种中花菜、西蓝花、莴笋、黄瓜、西红柿等保持稳定……'
					}, {
						id: 105, ym: '2026/10', day: '26', region: '山东', product: '水产', source: '青岛市城阳蔬菜水产品批发市场',
						title: '青岛市城阳蔬菜水产品批发市场：一周行情综述',
						summary: '本周白条猪价格上下波动不大，猪肉类产品价格较稳定。市场精猪肉9-11元/斤、猪前排11.5-13.5元/斤、猪肋排15-17元/斤、前后肘猪肉8-10元/斤、下五花肉12-14元/斤。牛羊肉价格保持稳定，牛肉41-43元/斤、羊肉41-43元/斤、羊排36-38元/斤。鸡肉类产品价格波动不大……'
					}, {
						id: 106, ym: '2026/10', day: '25', region: '北京', product: '水果', source: '北京新发地国际市场',
						title: '北京新发地市场：水果价格监测（2026.10.24）',
						summary: '本周水果整体价格稳中略降。苹果、梨等秋季大宗水果供应充足，价格环比小幅回落；柑橘类陆续上市，初期价格偏高，随着进货量增大预计将逐步走低；西瓜进入尾期，价格环比上涨……'
					}, {
						id: 107, ym: '2026/10', day: '24', region: '广东', product: '水果', source: '广州江南果菜批发市场',
						title: '广州江南果菜批发市场：进口水果行情周报',
						summary: '本周进口水果到港量增加，车厘子、榴莲价格环比回落明显。受海运船期影响，智利车厘子到货集中，批发价较上周下降约一成；东南亚榴莲供应稳定，价格保持高位震荡……'
					}, {
						id: 108, ym: '2026/10', day: '23', region: '河南', product: '畜禽', source: '河南万邦国际农产品物流股份有限公司',
						title: '郑州万邦国际物流园：畜禽产品一周价格运行',
						summary: '本周畜禽产品价格总体平稳。生猪出栏均价环比小幅波动，猪肉批发价随之调整；鸡蛋价格震荡走弱，主因蛋鸡存栏处于高位、需求跟进一般；牛羊肉价格保持稳定……'
					}, {
						id: 109, ym: '2026/10', day: '22', region: '四川', product: '蔬菜', source: '成都濛阳农副产品综合批发市场',
						title: '成都濛阳农副产品综合批发市场：蔬菜价格指数（2026.10.20）',
						summary: '本周濛阳市场蔬菜价格指数环比上涨1.2%。受本地降温影响，叶菜生长周期延长，供应量减少，价格上行；根茎类、菌菇类价格平稳。预计后期随外调菜增加，价格将趋于回落……'
					}, {
						id: 110, ym: '2026/10', day: '21', region: '辽宁', product: '蔬菜', source: '沈阳盛发国际蔬菜批发市场',
						title: '沈阳盛发蔬菜批发市场：一周行情分析',
						summary: '本周市场蔬菜供应以东北本地大田菜与南方调运菜为主，价格总体平稳。白菜、土豆、洋葱等大众菜价格保持低位；受降雨影响，叶菜类价格环比小幅上涨……'
					}, {
						id: 111, ym: '2026/10', day: '20', region: '江西', product: '水产', source: '南昌深圳农产品中心批发市场',
						title: '南昌深圳农产品中心批发市场：水产一周价格监测',
						summary: '本周水产价格稳中略涨。四大家鱼受季节影响出货量减少，草鱼、鲢鱼批发价环比上涨；小龙虾进入尾声，价格走高；蟹类供应充足，价格平稳……'
					}, {
						id: 112, ym: '2026/10', day: '19', region: '陕西', product: '粮油', source: '西安欣桥蔬菜批发市场',
						title: '西安欣桥蔬菜批发市场：粮油副食价格周报',
						summary: '本周粮油副食价格总体稳定。大米、面粉供应充足，价格平稳；食用油受国际行情影响小幅震荡；调味品、干货价格保持稳定，市场购销两旺……'
					},
				],
			}
		},
		computed: {
			pageCount() {
				return Math.max(1, Math.ceil(this.total / this.pageSize))
			},
			// 页码窗口：总数不多时全显；否则 首页 … 当前±2 … 末页（'...' 为省略占位）
			visiblePages() {
				const total = this.pageCount, cur = this.page, out = []
				if (total <= 7) {
					for (let i = 1; i <= total; i++) out.push(i)
					return out
				}
				out.push(1)
				let start = Math.max(2, cur - 2)
				let end = Math.min(total - 1, cur + 2)
				if (cur <= 3) { start = 2; end = 5 }
				if (cur >= total - 2) { start = total - 4; end = total - 1 }
				if (start > 2) out.push('...')
				for (let i = start; i <= end; i++) out.push(i)
				if (end < total - 1) out.push('...')
				out.push(total)
				return out
			},
			pagedList() {
				return this.newsList
			},
		},
		mounted() {
			this.fetchNews()
		},
		methods: {
			// 服务端分页拉取新闻资讯：category=3, period=0，按页传 pageNo/pageSize，关键字交后端模糊匹配
			fetchNews() {
				if (this.loading) return
				this.loading = true
				const params = { pageNo: this.page, pageSize: this.pageSize, category: 3, period: 0 }
				const kw = (this.applied.keyword || '').trim()
				if (kw) params.keyword = kw
				this.$request2('/admin-api/governance/pfsc-source-data/item-page', { params: params }).then(res => {
					this.loading = false
					if (!res || res.code !== 0 || !res.data) return
					const list = Array.isArray(res.data.list) ? res.data.list : []
					this.newsList = list.map(it => this.mapNewsRow(it))
					this.total = res.data.total != null ? res.data.total : this.newsList.length
				}).catch(() => { this.loading = false })
			},
			mapNewsRow(it) {
				let obj = {}
				try { obj = JSON.parse(it.data) || {} } catch (e) { obj = {} }
				const date = obj.publishDate || it.dataDate || ''
				const m = String(date).match(/(\d{4})-(\d{2})-(\d{2})/)
				const content = String(obj.contentstr || obj.content || '')
				return {
					id: it.id,
					ym: m ? m[1] + '/' + m[2] : '',
					day: m ? m[3] : '',
					date: date,
					source: obj.source || '',
					title: obj.title || '',
					content: content,
					summary: content.replace(/\s+/g, ' ').trim(),
				}
			},
			query() {
				this.applied = {
					region: this.filter.region,
					product: this.filter.product,
					keyword: this.filter.keyword
				}
				this.page = 1
				this.fetchNews()
			},
			reset() {
				this.filter = { region: '', product: '', keyword: '' }
				this.applied = { region: '', product: '', keyword: '' }
				this.page = 1
				this.fetchNews()
			},
			changePage(p) {
				if (p < 1 || p > this.pageCount || p === this.page) return
				this.page = p
				this.fetchNews()
			},
			goInfo(item) {
				if (!item) return
				this.detail = {
					title: item.title,
					source: item.source,
					date: item.date,
					html: '',
					text: item.content,
				}
			},
		},
	}
</script>

<style scoped lang="scss">
	.news-page {
		flex: 1;
		min-height: 0;
		overflow: auto;
		background: #f5f6f8;
		box-sizing: border-box;
	}

	.news-inner {
		max-width: 1300px;
		margin: 0 auto;
		padding: 20px;
	}

	/* ===== 筛选栏 ===== */
	.nf-bar {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 16px;
		padding: 16px 20px;
		background: #fff;
		border: 1px solid #eee;
		border-radius: 6px;
		box-sizing: border-box;
	}

	.nf-group {
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #666;
	}

	.nf-group label {
		white-space: nowrap;
	}

	.nf-group select,
	.nf-search input {
		height: 34px;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		padding: 0 10px;
		font-size: 14px;
		color: #333;
		background: #fff;
		outline: none;
		box-sizing: border-box;
	}

	.nf-group select {
		width: 150px;
	}

	.nf-search {
		flex: 1;
		min-width: 240px;
	}

	.nf-search input {
		flex: 1;
		min-width: 0;
	}

	.nf-query {
		height: 34px;
		padding: 0 28px;
		background: #22b573;
		color: #fff;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		font-size: 14px;
	}

	.nf-query:hover {
		background: #1ea166;
	}

	.nf-reset {
		height: 34px;
		padding: 0 28px;
		background: #fff;
		color: #22b573;
		border: 1px solid #22b573;
		border-radius: 4px;
		cursor: pointer;
		font-size: 14px;
	}

	/* ===== 列表 ===== */
	.nf-list {
		position: relative;
		margin-top: 16px;
		background: #fff;
		border: 1px solid #eee;
		border-radius: 6px;
		padding: 0 20px;
		box-sizing: border-box;
		min-height: 120px;
	}

	.nf-mask {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 12px;
		background: rgba(255, 255, 255, .75);
		border-radius: 6px;
		z-index: 5;
	}

	.nf-mask-text {
		font-size: 14px;
		color: #22b573;
	}

	.nf-spin {
		width: 30px;
		height: 30px;
		border: 3px solid #d6f0e4;
		border-top-color: #22b573;
		border-radius: 50%;
		animation: nf-rotate .8s linear infinite;
	}

	@keyframes nf-rotate {
		to {
			transform: rotate(360deg);
		}
	}

	.nf-item {
		display: flex;
		align-items: flex-start;
		padding: 20px 0;
		border-bottom: 1px solid #f0f0f0;
		cursor: pointer;
	}

	.nf-item:last-child {
		border-bottom: none;
	}

	.nf-item:hover .nf-title {
		color: #22b573;
	}

	.nf-date {
		flex: 0 0 76px;
		width: 76px;
		height: 76px;
		margin-right: 18px;
		border: 1px solid #e64b3c;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #e64b3c;
	}

	.d-ym {
		font-size: 13px;
	}

	.d-day {
		font-size: 30px;
		font-weight: 700;
		line-height: 1.1;
	}

	.nf-main {
		flex: 1;
		min-width: 0;
	}

	.nf-head {
		display: flex;
		align-items: baseline;
		justify-content: space-between;
	}

	.nf-title {
		flex: 1;
		min-width: 0;
		font-size: 17px;
		font-weight: 700;
		color: #333;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.nf-source {
		flex: 0 0 auto;
		max-width: 260px;
		margin-left: 16px;
		font-size: 13px;
		color: #999;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.nf-summary {
		margin-top: 10px;
		font-size: 14px;
		line-height: 1.7;
		color: #888;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	.nf-empty {
		padding: 60px 0;
		text-align: center;
		font-size: 15px;
		color: #999;
	}

	/* ===== 分页 ===== */
	.nf-pager {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 8px;
		margin-top: 16px;
		font-size: 14px;
		color: #666;
	}

	.pg-total {
		margin-right: auto;
	}

	.pg-btn,
	.pg-num {
		min-width: 34px;
		height: 34px;
		line-height: 32px;
		padding: 0 12px;
		text-align: center;
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		background: #fff;
		color: #333;
		cursor: pointer;
		box-sizing: border-box;
		user-select: none;
	}

	.pg-btn:hover,
	.pg-num:hover {
		border-color: #22b573;
		color: #22b573;
	}

	.pg-num.active {
		background: #22b573;
		border-color: #22b573;
		color: #fff;
	}

	.pg-num.ellipsis {
		border-color: transparent;
		background: transparent;
		cursor: default;
		color: #999;
		letter-spacing: 1px;
	}

	.pg-num.ellipsis:hover {
		border-color: transparent;
		color: #999;
	}

	.pg-btn.disabled {
		color: #c0c4cc;
		border-color: #ebeef5;
		cursor: not-allowed;
	}

	.pg-btn.disabled:hover {
		color: #c0c4cc;
		border-color: #ebeef5;
	}
</style>
